<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 align-self-center>
        <v-img
          cover
          class="align-center"
          :src="require('./../../assets/images/Group26.png')"
        >
          <v-layout wrap px-2 px-sm-16 px-md-0 px-lg-16 pt-4 pt-lg-2>
            <v-flex xs12 text-left pb-10 px-sm-16>
              <span
                :class="
                  $vuetify.breakpoint.name == 'xs' ? 'title13xs' : 'title13'
                "
                >Challenges
              </span>
            </v-flex>
            <v-flex xs12 text-left pb-4 px-sm-16>
              <span class="title14">The Challenge: </span>
            </v-flex>
            <v-flex xs12 lg12 text-justify pb-10 px-sm-16>
              <span class="title15"
                >Habitat destruction and poaching are the two major threats
                faced by tigers in the wild and until and unless we stop these
                two threats, the number of tigers will continue to decline. Some
                countries have deaccelerated the decline, and measures are taken
                to stabilize and increase the tiger population, that is the good
                news!
                <br>
                The challenge is not over, since every day there are tigers being killed for their skin and
body parts of young tiger cubs are trafficked to become captive live trophies in private
zoos, farmed for commercial exploitation of the body parts, or even in the backyards
across the globe! There is a need to put an end to these crimes and if we can get
people to come forward and work together, we can stop such crimes and devastation.
              </span>
            </v-flex>
            <v-flex xs12 align-self-center pl-sm-16>
              <v-layout wrap justify-start>
                <v-flex
                  xs12
                  md4
                  lg4
                  pr-sm-16
                  align-self-start
                  :py-3="
                    $vuetify.breakpoint.name == 'xs' ||
                    $vuetify.breakpoint.name == 'sm'
                      ? true
                      : false
                  "
                >
                  <v-layout wrap justify-start>
                    <v-flex xs1 align-self-start text-left pb-4>
                      <v-img
                        contain
                        height="22px"
                        width="22px"
                        :src="require('./../../assets/images/001-flag.png')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left>
                      <span class="title14"> Challenge A: </span>
                    </v-flex>
                    <v-flex xs12 align-self-center text-justify py-6>
                      <span class="title15">
                        Develop a centralized system that can collect, store,
                        process and disseminate information related to Illegal
                        Wildlife Trade (IWT) where the species involved is the
                        Tiger.
                        <br />
                        <br />
                        <ul class="a">
                          <li>Server based system using an advanced stalk</li>
                          <li>
                            User level access (Super Admin, Country Admin, App
                            Users and Visitors)
                          </li>
                          <li>
                            Analyst Module: To monitor the data and information
                            management.
                          </li>
                          <li>Dashboard with graphs and statistics.</li>
                          <li>
                            Criminal Incidents: Poaching or killing of Tigers,
                            Trafficking of Tiger or its body parts, illegal
                            capture or holding of tigers, arrest of persons
                            involved in tiger poaching (A suspects database),
                            convictions of suspects, incident diary where an
                            incident can be documented and kept with unique
                            keywords.
                          </li>
                          <li>
                            Tiger Crime News: Any news articles or information
                            extracts related to tigers where there is an element
                            of crime involved.
                          </li>
                        </ul>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  md4
                  lg4
                  pr-sm-16
                  :py-3="
                    $vuetify.breakpoint.name == 'xs' ||
                    $vuetify.breakpoint.name == 'sm'
                      ? true
                      : false
                  "
                >
                  <v-layout wrap>
                    <v-flex xs1 align-self-start text-left pb-4>
                      <v-img
                        contain
                        height="22px"
                        width="22px"
                        :src="require('./../../assets/images/001-flag.png')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left>
                      <span class="title14"> Challenge B: </span>
                    </v-flex>
                    <v-flex xs12 align-self-center text-justify py-6>
                      <span class="title15"
                        >Develop a bot or an automated tool which will scout the
                        digital space across various platforms and collect
                        information about tiger related crimes and direct the
                        information to a centralized database for further
                        automation or assisted analysis.
                        <br />
                        <br />
                        <ul class="a">
                          <li>Both iOS and Android Platforms</li>
                          <li>Access to the main dashboard of the server.</li>
                          <li>
                            Option to share information and communicate in
                            Cognito and Incognito modes.
                          </li>
                        </ul>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex
                  xs12
                  md4
                  lg4
                  pr-sm-16
                  :py-3="
                    $vuetify.breakpoint.name == 'xs' ||
                    $vuetify.breakpoint.name == 'sm'
                      ? true
                      : false
                  "
                >
                  <v-layout wrap>
                    <v-flex xs1 align-self-start text-left pb-6>
                      <v-img
                        contain
                        height="22px"
                        width="22px"
                        :src="require('./../../assets/images/001-flag.png')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left>
                      <span class="title14"> Challenge C: </span>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left py-6>
                      <span class="title15">
                        Develop a Mobile Application which can be used by people
                        volunteers to share information regarding tiger crimes
                        both in covert and overt modes. Previous experience or
                        knowledge of digital identity solutions.

                        <br />
                        <br />
                        <ul class="a">
                          <li>
                            Automated search based on customizable keywords,
                            region, time frame etc.
                          </li>
                          <li>
                            Ability to perform a deep search and apply regional
                            language search.
                          </li>
                          <li>
                            Store the search results in a centralized database
                            for further analysis.
                          </li>
                          <li>
                            To consider/investigate the use of digital
                            identities to help create a trusted network of
                            contributors.
                          </li>
                        </ul>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/Tigers.mp4"],
    };
  },
};
</script>
<style scoped>
ul.a {
  list-style-type: circle;
}
</style>